import { getFormattedPrice, type SupportedCurrency } from "./currencyUtils";
import { MembershipPlan, AppointmentPackage } from "../types/wizard-demo.types";

export function getPlanFeatures(planType: string): string[] {
  const featureMap: Record<string, string[]> = {
    Unlimited: ["Unlimited Access", "All Classes", "Priority Booking"],
    "Monthly Membership": ["Monthly Access", "Basic Classes", "Locker Room"],
    "10 Class Pack": [
      "10 Sessions",
      "Flexible Scheduling",
      "2 Month Validity",
    ],
    "Drop-in Classes": [
      "Single Session",
      "No Commitment",
      "Try Before You Buy",
    ],
    "Annual Membership": ["Full Year Access", "All Amenities", "Best Value"],
    "Student Discount": ["Student Pricing", "ID Required", "Monthly Access"],
    "Military/First Responder Discount": [
      "Special Pricing",
      "ID Required",
      "Monthly Access",
    ],
    "Family Plan": ["Up to 4 Members", "Family Pricing", "Shared Benefits"],
    "Personal Training": [
      "1-on-1 Training",
      "Customized Program",
      "Expert Guidance",
    ],
  };
  return (
    featureMap[planType] || [
      "Premium Features",
      "Expert Support",
      "Flexible Access",
    ]
  );
}

export function getSessionCount(packageType: string): string {
  if (packageType.includes("Single")) return "1";
  if (packageType.includes("5-Session")) return "5";
  if (packageType.includes("10-Session")) return "10";
  if (packageType.includes("Intro")) return "3";
  if (packageType.includes("4") || packageType.includes("Package"))
    return "4";
  if (packageType.includes("6")) return "6";
  if (packageType.includes("8")) return "8";
  return "1";
}

export function getFallbackMembershipPlans(
  currency: SupportedCurrency,
): MembershipPlan[] {
  return [
    {
      name: "Basic",
      price: getFormattedPrice(
        { USD: 99, AUD: 148, CAD: 134, GBP: 79 },
        currency,
      ),
      duration: "month",
      features: ["Gym Access", "Locker Room", "Basic Classes"],
      popular: false,
    },
    {
      name: "Premium",
      price: getFormattedPrice(
        { USD: 149, AUD: 223, CAD: 201, GBP: 119 },
        currency,
      ),
      duration: "month",
      features: [
        "All Basic Features",
        "Unlimited Classes",
        "Personal Training Session",
      ],
      popular: true,
    },
    {
      name: "Elite",
      price: getFormattedPrice(
        { USD: 199, AUD: 298, CAD: 269, GBP: 159 },
        currency,
      ),
      duration: "month",
      features: [
        "All Premium Features",
        "Nutrition Consultation",
        "Priority Booking",
      ],
      popular: false,
    },
  ];
}

export function getFallbackAppointmentPackages(
  currency: SupportedCurrency,
): AppointmentPackage[] {
  return [
    {
      name: "Single Session",
      sessions: "1",
      price: getFormattedPrice(
        { USD: 75, AUD: 112, CAD: 101, GBP: 60 },
        currency,
      ),
    },
    {
      name: "5-Session Pack",
      sessions: "5",
      price: getFormattedPrice(
        { USD: 350, AUD: 525, CAD: 473, GBP: 280 },
        currency,
      ),
    },
    {
      name: "10-Session Pack",
      sessions: "10",
      price: getFormattedPrice(
        { USD: 650, AUD: 975, CAD: 878, GBP: 520 },
        currency,
      ),
    },
  ];
}
